import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, CameraIcon, UserIcon, SettingsIcon } from 'lucide-react';
import { IOSShadow } from './IOSShadow';
export function Navigation() {
  const location = useLocation();
  const pathname = location.pathname;
  return <>
      {/* Smooth fading blur gradient */}
      <div className="fixed bottom-0 left-0 right-0 h-24 pointer-events-none z-10" data-id="element-33">
        <div className="absolute inset-0 bg-gradient-to-t from-white/70 via-white/20 to-transparent" data-id="element-34" />
      </div>
      {/* Navigation bar with balanced blur */}
      <div className="fixed bottom-0 left-0 right-0 w-full z-20 pb-safe" data-id="element-35">
        <IOSShadow intensity="medium" color="rgba(0,0,0,0.07)" data-id="element-36">
          <div className="mx-auto mb-4 w-[85%] max-w-sm rounded-full bg-white/40 backdrop-blur-xl border border-white/40" data-id="element-37">
            <div className="flex justify-around py-2 px-1" data-id="element-38">
              <Link to="/" className={`relative flex flex-col items-center p-2 transition-all ${pathname === '/' ? 'text-blue-500 scale-105' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-39">
                {pathname === '/' && <div className="absolute -top-1 w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-40" />}
                <HomeIcon size={22} strokeWidth={pathname === '/' ? 2.5 : 2} data-id="element-41" />
                <span className="text-[10px] mt-1 font-medium" data-id="element-42">Home</span>
              </Link>
              <Link to="/auramax" className={`relative flex flex-col items-center p-2 transition-all ${pathname === '/auramax' ? 'text-blue-500 scale-105' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-43">
                {pathname === '/auramax' && <div className="absolute -top-1 w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-44" />}
                <CameraIcon size={22} strokeWidth={pathname === '/auramax' ? 2.5 : 2} data-id="element-45" />
                <span className="text-[10px] mt-1 font-medium" data-id="element-46">Aura-Max</span>
              </Link>
              <Link to="/profile" className={`relative flex flex-col items-center p-2 transition-all ${pathname === '/profile' ? 'text-blue-500 scale-105' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-47">
                {pathname === '/profile' && <div className="absolute -top-1 w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-48" />}
                <UserIcon size={22} strokeWidth={pathname === '/profile' ? 2.5 : 2} data-id="element-49" />
                <span className="text-[10px] mt-1 font-medium" data-id="element-50">Profile</span>
              </Link>
              <Link to="/settings" className={`relative flex flex-col items-center p-2 transition-all ${pathname === '/settings' ? 'text-blue-500 scale-105' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-51">
                {pathname === '/settings' && <div className="absolute -top-1 w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-52" />}
                <SettingsIcon size={22} strokeWidth={pathname === '/settings' ? 2.5 : 2} data-id="element-53" />
                <span className="text-[10px] mt-1 font-medium" data-id="element-54">Settings</span>
              </Link>
            </div>
          </div>
        </IOSShadow>
      </div>
    </>;
}